import { AnimatePresence } from 'framer-motion';

import { Box } from '@mui/material';

import backgroundFooter from 'assets/images/admission-background-footer.png';
import backgroundHeader from "assets/images/admission-background-header.png";

const Wrapper = (props) =>
  <Box elevation={2} sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }} {...props} />;

const BackgroundImage = ({ sx }) =>
  <Box sx={{ width: '100%', position: 'absolute', backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat', ...sx }} />


const FullScreenLayout = (props) => {

  return (
    <Wrapper >
      <AnimatePresence exitBeforeEnter initial={true}>
        {props.children}
      </AnimatePresence>
      <BackgroundImage sx={{ height: '60vh', zIndex: '1', top: '0', backgroundImage: `url(${backgroundHeader})` }} />
      <BackgroundImage sx={{ height: '70vh', zIndex: '0', bottom: '0', backgroundImage: `url(${backgroundFooter})` }} />
    </Wrapper>
  );
}

export default FullScreenLayout;